import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Text from '@jetbrains/ring-ui/components/text/text';
import CopiedText from '@common/clipboard/copied-text/copied-text';
import { useServerConfigContext } from '@common/server-config-context/server-config-context';
import PluginDownloads from './plugin-downloads';
import styles from './plugin-info.css';
function PluginInfo({ plugin, downloadsEnabled = true }) {
    const serverConfig = useServerConfigContext();
    const analyticsEnabled = serverConfig.isAnalyticsEnabled();
    return (_jsxs("div", { className: styles.infoContainer, children: [_jsxs(Text, { children: ["Plugin ID: ", _jsx(CopiedText, { text: plugin.id })] }), _jsxs(Text, { children: ["Vendor: ", plugin.vendor] }), analyticsEnabled && downloadsEnabled && _jsx(PluginDownloads, { pluginId: plugin.id })] }));
}
export default PluginInfo;
